// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Q3lB","insightsList":"newBusinessInsightsMenu_insightsList__fyZA0","active":"newBusinessInsightsMenu_active__2_4K1"};